module.exports = __webpack_public_path__ + "static/media/laptop-frame.694a3a45.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/laptop-frame.png
// module id = 98
// module chunks = 0